import "babel-polyfill";

import {binder, fwa} from "./libs/binder";
import "./libs/slick";
import "jquery-mousewheel";
import "./libs/jquery.mCustomScrollbar";
import "./libs/jcf";
import "./libs/jcf.number";
import "./libs/jcf.scrollable";
import "./libs/jcf.select";

import {constants} from "./modules/module";
import {mobileMenu} from "./modules/mobileMenu";
import {homeHeader} from "./modules/homeHeader";
import {logosSlider} from "./modules/logosSlider";
import {galleryScroll} from "./modules/galleryScroll";
import {reviewsScroll} from "./modules/reviewsScroll";
import {teamSlider} from "./modules/teamSlider";
import {isIos} from "./modules/is-ios";
import {initMenuTabs} from "./modules/menu-section-tabs";
import {menuSectionSlider} from "./modules/menu-section-slider";
import {ourMenuSlider} from "./modules/our-menu-slider";
import {setStickyElement} from "./modules/set-sticky-element";
import {scrollToAnchors} from "./modules/scroll-to-anchors";
import {scrollToLocation} from "./modules/scroll-to-location";
import {toggleBookingWidget} from "./modules/toggle-booking-widget";
import {stickyOrder} from "./modules/sticky-order";
import {inputPlaceholders} from "./modules/inputs";
import {jcfInit} from "./modules/jcf-init";
import {eventScroll} from "./modules/event-scroll";
import {homeLocations} from "./modules/home-locations";
import {aboutUs} from "./modules/about-us"
import {sctickyHeader} from "./modules/sctickyHeader"
import {processVisitModal} from "./modules/visit-modal"

import "./modules/jquery-ui";
import {datepicker} from "./modules/datepicker";

binder({
	bounds: {
		"html": [mobileMenu, constants, isIos, scrollToAnchors, toggleBookingWidget,processVisitModal],
		".wrapper.home": homeHeader,
        ".home": stickyOrder,
		".logos-slider": logosSlider,
		".photos-wrap": galleryScroll,
		".reviews-thumbnails": reviewsScroll,
		".team-slider": teamSlider,
        ".menu-section .tabs": initMenuTabs,
        ".page-template-page-our-menu .menu-section .menu-gallery": menuSectionSlider,
        ".sticky-parent": setStickyElement,
        ".page-template-page-our-menu-new .menu-gallery": ourMenuSlider,
		".page-template-page-our-menu-new, .page-template-page-locations": scrollToLocation,
        ".with-label": inputPlaceholders,
        "select": jcfInit,
		".datepicker": datepicker,
		".page-template-page-events": eventScroll,
		'.home-locations': homeLocations,
		".slider-about-us": aboutUs,
		".header": sctickyHeader
	},
	runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js